import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { authApi } from '../../services/endpoints';

function ChangePasswordForm() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    if (next !== confirm) {
      setStatus({ type: 'error', message: 'Passwords do not match' });
      return;
    }
    if (next.length < 12) {
      setStatus({ type: 'error', message: 'Password must be at least 12 characters' });
      return;
    }
    setBusy(true);
    try {
      await authApi.changePassword(current, next);
      setStatus({ type: 'success', message: 'Password changed' });
      setCurrent(''); setNext(''); setConfirm('');
    } catch (err) {
      setStatus({ type: 'error', message: err?.response?.data?.detail || 'Failed to change password' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3 max-w-sm">
      <input type="password" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} required autoComplete="current-password" className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/20 text-white" />
      <input type="password" placeholder="New password (12+ characters)" value={next} onChange={(e) => setNext(e.target.value)} required minLength={12} autoComplete="new-password" className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/20 text-white" />
      <input type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/20 text-white" />
      {status && (
        <p className={status.type === 'error' ? 'text-red-400 text-sm' : 'text-green-400 text-sm'}>{status.message}</p>
      )}
      <button type="submit" disabled={busy} className="btn-primary !py-2 !px-4 text-sm disabled:opacity-50">
        {busy ? 'Saving…' : 'Update password'}
      </button>
    </form>
  );
}

export default function Account() {
  const user = useAuthStore((s) => s.user);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Account</h1>

      <div className="glass rounded-xl p-6 mb-6 max-w-lg">
        <p className="font-medium">{user?.name}</p>
        <p className="text-white/50 text-sm">{user?.email}</p>
        <p className="text-white/30 text-xs mt-1 capitalize">{user?.role}</p>
      </div>

      <h2 className="text-lg font-semibold mb-3">Change password</h2>
      <ChangePasswordForm />

      <div className="mt-10 pt-6 border-t border-white/10 max-w-lg">
        <h2 className="text-lg font-semibold mb-2 text-red-400">Danger zone</h2>
        <p className="text-white/50 text-sm mb-3">
          Permanently delete your account and all associated data.
        </p>
        <Link to="/account-deletion" className="text-sm text-red-400 hover:text-red-300 underline">
          Delete my account →
        </Link>
      </div>
    </div>
  );
}
